import React from "react";
import { useLocation } from "react-router-dom";
import { Card, Column, Columns, StackSection } from "@origin-digital/ods-core";
import { Search } from "./index";
import { content } from "../../content";
import { isLandingPath } from "../../helpers/routes";
import { SearchSectionWrapper } from "./styles";

export const SearchSection: React.FC = () => {
  const { pathname } = useLocation();
  const isLandingPage = isLandingPath(pathname);

  return (
    <SearchSectionWrapper>
      <StackSection
        backgroundColor="cardBackground"
        width="xlarge"
        space="none"
        hideGutter={false}
      >
        <Card
          backgroundColor="transparent"
          paddingXSpecific={{
            xs: isLandingPage ? "medium" : "none",
            lg: "none",
          }}
          paddingYSpecific={{
            xs: isLandingPage ? "xxxlarge" : "none",
            sm: isLandingPage ? "xxxlarge" : "none",
            lg: isLandingPage ? "xxxlarge" : "none",
          }}
        >
          {isLandingPage ? (
            <Columns collapseBelow="lg" alignX="center">
              <Column width="2/3">
                <Search
                  heading={content.search.heading}
                  searchPlaceholder={content.search.placeholder}
                />
              </Column>
            </Columns>
          ) : (
            <Search searchPlaceholder={content.search.placeholder} />
          )}
        </Card>
      </StackSection>
    </SearchSectionWrapper>
  );
};
